import { formatFullName } from "src/utils";
import styles from "./cardSetting.module.scss";
import { EMPTY_STRING } from "src/components/constant/constant";
import { CardSettingType } from "./cardSettingSlice";
import { ApprovalNumber, DateStack, MemberCell, WalletCell } from "src/components/UI/transactionCells";

const columns = [
  {
    title: "Id",
    dataIndex: "card_setting_id",
    key: "card_setting_id"
  },
  {
    title: "Ppan",
    dataIndex: "ppan",
    key: "ppan",
    render: (ppan: string) => (
      <ApprovalNumber value={ppan ? ppan.slice(-4) : undefined} masked={Boolean(ppan)} />
    )
  },
  {
    title: "Card Setting Status",
    dataIndex: "card_setting_status",
    key: "card_setting_status"
  },
  {
    title: "Card Id",
    dataIndex: "card_id",
    key: "card_id"
  },
  {
    title: "Expiry At",
    dataIndex: "expires_at",
    key: "expires_at",
    render: (expires_at: string) => <DateStack value={expires_at || EMPTY_STRING} />
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status: string) => (
      <div className={styles.tableCardStatus}>
        <div className={`${status === "ACTIVE" ? styles.green : styles.grey}`}>{status}</div>
      </div>
    )
  },
  {
    title: "User",
    dataIndex: "user_id",
    key: "user_id",
    render: (user_id: string, data: CardSettingType) => (
      <MemberCell
        fullName={data.user ? formatFullName(data.user.first_name, data.user.last_name) : undefined}
        email={data.user?.email}
        userId={user_id}
        fallback={<span>{user_id}</span>}
      />
    )
  },
  {
    title: "Card",
    dataIndex: "wallet_id",
    key: "wallet_id",
    render: (wallet_id: string, data: CardSettingType) => (
      <WalletCell
        walletId={wallet_id}
        name={data.wallet?.name}
        description={data.wallet?.description ?? undefined}
        fallback={<span>{wallet_id}</span>}
      />
    )
  },
  {
    title: "Type",
    dataIndex: "sub_type",
    key: "sub_type"
  },
  {
    title: "Updated At",
    dataIndex: "updated_at",
    key: "updated_at",
    render: (updated_at: string) => <DateStack value={updated_at} />
  }
];

export default columns;
